
const assertString = (input: unknown) => {
    if (input === undefined || input === null) throw new TypeError(`Expected a string but received a ${input}`)
    if (input.constructor.name !== 'String') throw new TypeError(`Expected a string but received a ${input.constructor.name}`)
}

const IPv4SegmentFormat = '(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])'
const IPv4AddressFormat = `(${IPv4SegmentFormat}[.]){3}${IPv4SegmentFormat}`
const IPv4AddressRegExp = new RegExp(`^${IPv4AddressFormat}$`)

const IPv6SegmentFormat = '(?:[0-9a-fA-F]{1,4})'
const IPv6AddressRegExp = new RegExp('^('
    + `(?:${IPv6SegmentFormat}:){7}(?:${IPv6SegmentFormat}|:)|`
    + `(?:${IPv6SegmentFormat}:){6}(?:${IPv4AddressFormat}|:${IPv6SegmentFormat}|:)|`
    + `(?:${IPv6SegmentFormat}:){5}(?::${IPv4AddressFormat}|(:${IPv6SegmentFormat}){1,2}|:)|`
    + `(?:${IPv6SegmentFormat}:){4}(?:(:${IPv6SegmentFormat}){0,1}:${IPv4AddressFormat}|(:${IPv6SegmentFormat}){1,3}|:)|`
    + `(?:${IPv6SegmentFormat}:){3}(?:(:${IPv6SegmentFormat}){0,2}:${IPv4AddressFormat}|(:${IPv6SegmentFormat}){1,4}|:)|`
    + `(?:${IPv6SegmentFormat}:){2}(?:(:${IPv6SegmentFormat}){0,3}:${IPv4AddressFormat}|(:${IPv6SegmentFormat}){1,5}|:)|`
    + `(?:${IPv6SegmentFormat}:){1}(?:(:${IPv6SegmentFormat}){0,4}:${IPv4AddressFormat}|(:${IPv6SegmentFormat}){1,6}|:)|`
    + `(?::((?::${IPv6SegmentFormat}){0,5}:${IPv4AddressFormat}|(?::${IPv6SegmentFormat}){1,7}|:))`
    + ')(%[0-9a-zA-Z.]{1,})?$')

export const isIP = (ipAddress: string, version = 0): boolean => {
    assertString(ipAddress)

    if (version === 0) {
        return isIP(ipAddress, 4) || isIP(ipAddress, 6)
    }

    if (version === 4) {
        return IPv4AddressRegExp.test(ipAddress)
    }

    if (version === 6) {
        return IPv6AddressRegExp.test(ipAddress)
    }

    return false
}
